export default __webpack_public_path__ + "static/media/presentation.1ab0e988.pptx";